export default class CopyToClipboard {
  constructor (container, result) {
    this.container = container
    this.result = result
    this.init()
  }

  copyContent (ev) {
    ev.target.setSelectionRange(0, ev.currentTarget.innerHTML.length)
    this.result.classList.remove('is-hidden')
    try {
      document.execCommand('copy')
      this.result.classList.add('success')
      this.result.innerHTML = 'Copied to clipboard'
    } catch (err) {
      this.result.classList.add('fail')
      this.result.innerHTML = 'Failed to copy to clipboard'
      console.log(err)
    }
  }

  init () {
    this.container.addEventListener('click', (ev) => this.copyContent(ev))
  }
}
